import { baseSecurityConfig } from './configBase';

export const pwcSecurityConfig = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN_PWC,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID_PWC,
  authorizationParams: {
    ...baseSecurityConfig,
    prompt: 'login',
    certificateType: 'hard',
    certificateProvider: 'pwc-idam',
    loginHint: 'cert_required',
    redirect_uri: window.location.origin,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE_PWC,
  },
};
